import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { KPI_CARD_HEIGHT_PX } from "@/constants";
import { AppKpiCardView } from "@/features/app-studio/ui/AppKpiCardView";
import type { CardDefinition } from "@/features/chat/model/chatTypes";

type CardsPanelProps = {
  cards: CardDefinition[];
  /** Opens the add-to-app dialog, where the user picks which cards to add. */
  onAddToApp?: () => void;
};

export function CardsPanel({ cards, onAddToApp }: CardsPanelProps) {
  const { t } = useTranslation("chat");

  if (cards.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {onAddToApp ? (
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Tooltip title={t("response.cards.addToApp")}>
            <IconButton
              size="small"
              aria-label={t("response.cards.addToApp")}
              onClick={onAddToApp}
              sx={{ color: "var(--theme-text-secondary)" }}
            >
              <DashboardCustomizeOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ) : null}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(1, 1fr)",
            sm: "repeat(2, 1fr)",
            md: "repeat(2, 1fr)",
            lg: "repeat(2, 1fr)",
            xl: "repeat(3, 1fr)",
          },
          gap: 2,
        }}
      >
        {cards.map((card) => (
          <AppKpiCardView
            key={card.id}
            name={card.title}
            format={card.format}
            value={card.value}
            heightPx={KPI_CARD_HEIGHT_PX}
          />
        ))}
      </Box>
    </Box>
  );
}
